export default __webpack_public_path__ + "static/curiocards-278b35fa7c2ee6a8258e00828e667c07.jpg";